export default __webpack_public_path__ + "static/media/horizontal.b553dd95.png";